import { render, staticRenderFns } from "./CompetitionSets.vue?vue&type=template&id=ec971440&scoped=true&"
import script from "./CompetitionSets.vue?vue&type=script&lang=js&"
export * from "./CompetitionSets.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionSets.vue?vue&type=style&index=0&id=ec971440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec971440",
  null
  
)

export default component.exports